// extracted by mini-css-extract-plugin
export default {"wrapper":"PhasesForm_wrapper__hHfON","container":"PhasesForm_container__lQ6Sb","icons":"PhasesForm_icons__AJoRS","drop-down-icon":"PhasesForm_drop-down-icon__JJLPL"};